import { SentryApplication } from "./sentry";
import { Mask } from "./mask";
import { Menu } from "./menu";
import { Policies } from "./policies";
import { Negotiation } from "./negotiation";

SentryApplication.sentryInitializer(
  "https://190f42a875bf426ca5b85d93c99c8d55@o92838.ingest.sentry.io/5812288",
  quiteja.config.VERSION
);

$(document).ready(() => {
    Mask.changeLabelDocumentListener()
    Menu.menuMobileOpenAndCloseListener()
    Menu.knowMoreDropDownListener()
    Menu.knowMoreMobileListener()
    Menu.subMenuMobileCloseListener()
    Menu.partnersMobileListener()
    Menu.partnersDropDownListener()
    Menu.scrollToHelpListener()
    Policies.policeModalListener()
    Negotiation.dialogPrivacyListener()
    Negotiation.setReferrer()
    Negotiation.verifyKeyCodeListener()
    Negotiation.submitDocumentFormListener()
    Negotiation.saveCookiesListener()
})

